// Vite env access isolated here so Jest (CJS, no import.meta support) can map
// this module to src/__mocks__/lib/env.ts — same pattern as @/lib/utils.
export const API_BASE = import.meta.env.VITE_API_URL || '/api/v1';
export const LANDING_AGENCY_ID = import.meta.env.VITE_LANDING_AGENCY_ID || '';
// Sign in with Google (auth 007). Vacío = el botón no se renderiza (fail-soft).
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';
